/** @jsx jsx */
import { Fragment } from "react"
import { jsx } from "theme-ui"
const AmazonRelatedProducts = () => (
    <Fragment>
    <div id="amzn-assoc-ad-b643e9bd-69ed-4231-a262-a027090f0220"></div>
<script async src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=b643e9bd-69ed-4231-a262-a027090f0220"></script>
    </Fragment>
)
export default AmazonRelatedProducts